
    import {
        Options,
        Vue
    } from 'vue-class-component';

    @Options({
        props: {
            staff: Object,
        }
    })
    export default class StaffItem extends Vue {
        // msg!: string
        staff!: any;
      
        private item_click():void{
            localStorage.setItem("pageData", JSON.stringify(this.staff));
            this.$router.push({
                name: 'StaffDetail'
            })
        }
        // public ondd(){
        //     console.log("1");
        // }
    } 
